import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ErrorPage from './modules/errorPage/ErrorPage';

class ErrorBounary extends Component {
    constructor(props) {
        super(props);
        this.state = { errorInfo: null };
    }

    componentDidMount() {
        // console.error(error);
        console.log('');
    }

    componentDidCatch(errorInfo) {
        this.setState({
            errorInfo
        });
    }

    render() {
        const { errorInfo } = this.state;
        const { children } = this.props;
        if (errorInfo) {
            // Error path
            return (
                <div>
                    <ErrorPage />
                </div>
            );
        }
        // Normally, just render children, i.e. in
        // case no error is Found
        return children;
    }
}

ErrorBounary.propTypes = {
    children: PropTypes.oneOfType([PropTypes.func, PropTypes.node])
};

export default ErrorBounary;
